import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export interface PeriodChangeEvent {
  currentMonth: Date;
  /** Datas em formato ISO (string), expostas com nomes simples */
  startDate: string;
  endDate: string;
}

@Component({
  selector: "app-period-selector",
  templateUrl: "./period-selector.component.html",
  styleUrls: ["./period-selector.component.scss"],
})
export class PeriodSelectorComponent implements OnInit {
  @Input() initialDate: Date | null = null;
  @Input() disabled: boolean | null = false;
  @Input() allowFutureNavigation = false;

  @Output() periodChange = new EventEmitter<PeriodChangeEvent>();

  currentMonth: Date = new Date();
  private startDateObj: Date = new Date();
  private endDateObj: Date = new Date();

  private readonly months = [
    "jan.",
    "fev.",
    "mar.",
    "abr.",
    "mai.",
    "jun.",
    "jul.",
    "ago.",
    "set.",
    "out.",
    "nov.",
    "dez.",
  ];

  ngOnInit(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const initialMonth = this.initialDate
      ? new Date(this.initialDate)
      : new Date();
    initialMonth.setDate(1);
    initialMonth.setHours(0, 0, 0, 0);

    const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    if (!this.allowFutureNavigation && initialMonth > todayMonth) {
      this.currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    } else {
      this.currentMonth = new Date(
        initialMonth.getFullYear(),
        initialMonth.getMonth(),
        1,
      );
    }
    this.updateDates(true);
  }

  get startDateFormatted(): string {
    return this.getFormattedDate(this.startDateObj);
  }

  get endDateFormatted(): string {
    return this.getFormattedDate(this.endDateObj);
  }

  onPreviousClick(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() - 1,
      1,
    );
    this.updateDates(true);
  }

  onNextClick(): void {
    if (this.canNavigateNext()) {
      this.currentMonth = new Date(
        this.currentMonth.getFullYear(),
        this.currentMonth.getMonth() + 1,
        1,
      );
      this.updateDates(true);
    }
  }

  canNavigateNext(): boolean {
    if (this.allowFutureNavigation) {
      return true;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const nextMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() + 1,
      1,
    );

    const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    // Não permite navegar para meses futuros
    return nextMonth <= todayMonth;
  }

  private updateDates(emit = false): void {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();

    this.startDateObj = new Date(year, month, 1);
    this.endDateObj = new Date(year, month + 1, 0);

    const startDate = this.toBackendDateTime(this.startDateObj);
    const endDate = this.toBackendDateTime(this.endDateObj);

    if (emit) {
      this.periodChange.emit({
        currentMonth: this.currentMonth,
        startDate,
        endDate,
      });
    }
  }

  private toBackendDateTime(date: Date): string {
    return date.toISOString();
  }

  private getFormattedDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, "0");
    const month = this.months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }
}
